import { getLocalStorage } from 'helpers/local-storage'
import countryLang from 'constants/language'

// The languages the app actually ships translations for, and the only ones the
// language popover offers. locales/i18n registers resources for exactly these.
const SUPPORTED_LANGUAGES = countryLang.map((lang) => lang.id)

// Indonesian, matching `defaultLang` in config.ts (allLangs[0]) and i18n's
// fallbackLng. Taken from countryLang's own first entry rather than importing
// config.ts, which pulls MUI's locale bundles in — this helper is read by
// helpers/api-client, and the axios layer should stay cheap to import.
const FALLBACK_LANGUAGE = countryLang[0].id

/**
 * The language the user is currently reading the app in.
 *
 * Read from localStorage rather than from the i18next instance so callers
 * outside React — the axios layer stamping the `Language` header — can ask
 * without importing the i18n setup. `i18nextLng` is written by
 * i18next-browser-languagedetector's cache whenever `changeLanguage` runs, so
 * it tracks the popover.
 *
 * Anything unrecognised falls back rather than being passed through. The stored
 * value is not guaranteed to be one we support: the detector caches whatever
 * i18next resolved to, which can be a region-qualified tag like `en-US` picked
 * up from `navigator`. Forwarding that verbatim would put a language the BE
 * has no copy for on every request.
 */
export const getActiveLanguage = (): string => {
  const stored = getLocalStorage('i18nextLng')
  return SUPPORTED_LANGUAGES.includes(stored)
    ? stored
    : FALLBACK_LANGUAGE
}
